module.exports = function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isRegExp.js
// module id = 342
// module chunks = 20976610436329 34471704633725 35783957827783 36151919715062 79452207145414 135858987226052 151509672496158